import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { Text } from '@omilia/typography';

export const SContainer = styled.div<{ left: string; top: string }>`
  background-color: ${colors.COLOR_GREY_200};
  border: 1px solid ${colors.COLOR_GREY_300};
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: 5px 10px 20px 0px ${colors.COLOR_GREY_400};
  color: ${colors.COLOR_GREY_1000};
  left: ${({ left }) => left};
  min-width: 400px;
  position: absolute;
  top: ${({ top }) => top};
  z-index: 9999;
`;

export const STitle = styled(Text)`
  padding: 11px 20px;
`;

export const SBody = styled(Text)`
  padding: 16px 65px 20px 20px;
`;

export const SHr = styled.hr`
  height: 1px;
  margin: 0;
`;
